import React, { useState } from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';
import { Search, Filter } from 'lucide-react';
import EventLogPanel, { SEVERITY } from './EventLogPanel';

export default function EventLogPage() {
  const [filters, setFilters] = useState({ severity: '', eventId: '', search: '', from: '', to: '' });
  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  const { data: summary } = useQuery(
    'events-summary',
    () => api.get('/events/summary').then(r => r.data),
    { refetchInterval: 30000 }
  );

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold">Registro de eventos</h1>
        <p className="text-gray-400 text-sm">
          Incidencias del sistema telefónico: troncales, canales y supervisión.
        </p>
      </div>

      {/* Resumen de las últimas 24 h */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Object.entries(SEVERITY).map(([key, s]) => {
          const Icon = s.icon;
          return (
            <div key={key} className="card p-4 flex items-center gap-3">
              <Icon className={`w-6 h-6 ${s.cls}`} />
              <div>
                <div className="text-2xl font-semibold">{summary?.counts?.[key] ?? 0}</div>
                <div className="text-xs text-gray-400">{s.label} · 24 h</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Filtros */}
      <div className="card p-4 grid grid-cols-1 md:grid-cols-5 gap-3">
        <div className="relative md:col-span-2">
          <Search className="w-4 h-4 absolute left-3 top-3 text-muted" />
          <input
            aria-label="Buscar en los detalles"
            className="input pl-9 w-full"
            placeholder="Buscar en los detalles…"
            value={filters.search}
            onChange={e => set('search', e.target.value)}
          />
        </div>
        <select aria-label="Gravedad" className="input" value={filters.severity} onChange={e => set('severity', e.target.value)}>
          <option value="">Todas las gravedades</option>
          {Object.entries(SEVERITY).map(([k, s]) => <option key={k} value={k}>{s.label}</option>)}
        </select>
        <input
          aria-label="ID del evento"
          className="input"
          placeholder="ID del evento (ej. 12294)"
          value={filters.eventId}
          onChange={e => set('eventId', e.target.value)}
        />
        <button
          className="btn-secondary flex items-center justify-center gap-2"
          onClick={() => setFilters({ severity: '', eventId: '', search: '', from: '', to: '' })}
        >
          <Filter className="w-4 h-4" /> Limpiar
        </button>
      </div>

      <EventLogPanel filters={filters} />
    </div>
  );
}
